import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: auto;
  min-height: 100%;
  padding: 16px;
  background-color: ${COLORS.black};
`;

export default Body;
